// extracted by mini-css-extract-plugin
export var caret = "ExpandableOutcomes-module--caret--29df6";
export var collapsed = "ExpandableOutcomes-module--collapsed--aacc9";
export var showMorePill = "ExpandableOutcomes-module--showMorePill--0410b";
export var toggle = "ExpandableOutcomes-module--toggle--0e40d";